<template>
<div class="chapter">
<div class="inner_page">
<div class="PL_Title-Page-Dividing-Line" id="_idContainer001">
<p class="pl-fl-roman"><a id="here"></a><b>A convenient arrangement: Three festive Regency romances!</b></p>
<p class="pl-fl-roman">In <i>The Captain’s Christmas Journey</i> by Carla Kelly, Captain Everard is escorting Verity to her governess job—and for propriety’s sake that means a convenient engagement! </p>
<p class="pl-fl-roman">In Louise Allen’s <i>The Viscount’s Yuletide Betrothal</i>, Eleanor advertises for a “suitable” gentleman to pose as her betrothed over Christmas. </p>
<p class="pl-fl-roman">And in Laurie Benson’s novella, Juliet Sommersby’s <i>One Night Under the Mistletoe</i> leads to a marriage of convenience with handsome former love Lord Montague...<br/><br/></p>
<p class="pl-epigraph">“A lovely, whimsical tale with unforgettable characters and richly detailed prose and lots of Christmas magic thrown in. The story of long-lost lovers finding each other against all odds proves a powerful one.”</p>
<p class="pl-citation">—<i>RT Book Reviews</i> on “Captain Grey’s Christmas Proposal” in <em class="italic">Regency Christmas Wishes</em></p>
<p class="pl-epigraph">“An enchanting, enjoyable and tender hearted historical romance about second chances, convenient arrangements and everlasting love.” </p>
<p class="pl-citation">—<i>Goodreads</i> on <em class="italic">The Earl’s Practical Marriage</em> </p>
<p class="pl-epigraph">“A very beautiful fantastic book by an author who never lets us down, truly utterly adored from start to finish.”</p>
<p class="pl-citation">—<i>Goodreads</i> on <em class="italic">An Unexpected Countess</em> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Back_Cover_Text.vue?289a4f9e